// PrestigeModal.tsx
import React from 'react';
import './PrestigeModal.css';
import type { PrestigeUpgrade } from '../../services/prestigeService';
import PrestigeUpgradeDisplay from './PrestigeUpgradeDisplay';

interface PrestigeModalProps {
  currentPrestigeScore: number;
  threshold: number;
  availableUpgrades: PrestigeUpgrade[];
  selectedUpgrade: PrestigeUpgrade | null;
  onSelectUpgrade: (upgrade: PrestigeUpgrade) => void;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

const PrestigeModal: React.FC<PrestigeModalProps> = ({
  currentPrestigeScore,
  threshold,
  availableUpgrades,
  selectedUpgrade,
  onSelectUpgrade,
  onConfirm,
  onCancel,
  loading
}) => {
  return (
    <div className="modal-backdrop">
      <div className="prestige-modal">
        <div className="prestige-modal-header">
          <h2>Prestige Available!</h2>
          <button className="close-button" onClick={onCancel}>&times;</button>
        </div>
        
        <div className="prestige-modal-content">        
          <div className="prestige-upgrade-selection">
            <h3>Select a Mothership Upgrade</h3>
            {availableUpgrades.length > 0 ? (
              <>
                <div style={{ textAlign: 'center', marginBottom: '15px', color: '#ccc', fontSize: '0.9em' }}>
                  Choose one upgrade to enhance your mothership permanently
                </div>
                <PrestigeUpgradeDisplay 
                  upgrades={availableUpgrades}
                  selectedUpgrade={selectedUpgrade}
                  onSelectUpgrade={onSelectUpgrade}
                />
              </>
            ) : (
              <div className="no-upgrades">No upgrades available</div>
            )}
          </div>

                    <div className="prestige-info">           
            <div className="prestige-warning">
              <strong>Warning:</strong> Prestiging will reset your fleet and resources!
              <br/> BUT you'll keep existing mothership upgrades and gain a new mothership upgrade.
            </div>
          </div>  
        </div>
        
        
        <div className="prestige-modal-footer">
          <button 
            className="confirm-button" 
            onClick={onConfirm}
            disabled={!selectedUpgrade || loading}
          >
            {loading ? 'Processing...' : 'Prestige Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrestigeModal;
